/*
 * Copyright 2023 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
import { DialogContent } from "@material-ui/core";
import React, { FunctionComponent } from "react";
import { DrawerContentV1Props } from "./drawer-content-v1.interfaces";
import { useDrawerContentV1Styles } from "./drawer-content-v1.styles";

export const DrawerContentV1: FunctionComponent<DrawerContentV1Props> = ({
    children,
}) => {
    const classes = useDrawerContentV1Styles();

    // Render UI
    return (
        <DialogContent
            dividers
            classes={{
                root: classes.root,
            }}
        >
            {children}
        </DialogContent>
    );
};
